import { render, staticRenderFns } from "./warning-bi.vue?vue&type=template&id=530f6625&scoped=true&"
import script from "./warning-bi.vue?vue&type=script&lang=js&"
export * from "./warning-bi.vue?vue&type=script&lang=js&"
import style0 from "./warning-bi.vue?vue&type=style&index=0&id=530f6625&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f6625",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530f6625')) {
      api.createRecord('530f6625', component.options)
    } else {
      api.reload('530f6625', component.options)
    }
    module.hot.accept("./warning-bi.vue?vue&type=template&id=530f6625&scoped=true&", function () {
      api.rerender('530f6625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/power-bi/components/warning-bi/warning-bi.vue"
export default component.exports